export const MAX_ASSESSMENT_AREA_HA = 3500;
